export enum GlobalMyAccountProfileRoutes {
  BASE = 'myaccount-profile',
  DELIVERY_ADDRESS_LIST = 'delivery-addresses'
}
